import React from "react"
import { Autocomplete, TextField } from "@mui/material";
import useAdditionalFilters from "../../hooks/useAdditionalFilters";
import { AdditionalFiltersInterface } from "../../types";
import { Primary } from "../../../../core-components/theme/color-palette/colors";

const AdditionalFilters = ({selectedCategory, selectedSubCategory, handleCategorySelect, handleSubCategorySelect, parentSxProps={}}: AdditionalFiltersInterface) => {
  const {FMSFolderStructure, categoryInputValue, subCategoryInputValue, setCategoryInputValue, setSubCategoryInputValue} = useAdditionalFilters();
  return (
    <React.Fragment>
      <Autocomplete
        value={selectedCategory}  
        onChange={(event: any, newValue: string | null) => {
          handleCategorySelect(newValue ?? '');
        }}
        inputValue={categoryInputValue}
        onInputChange={(event, newInputValue) => {
          setCategoryInputValue(newInputValue);
        }}
        id="category-select"
        options={FMSFolderStructure?.category || []}
        renderInput={(params) => <TextField {...params} label="Category" />}
        sx={{background: Primary[50], flex: 1}}
      />
      <Autocomplete
        value={selectedSubCategory}
        onChange={(event: any, newValue: string | null) => {
          handleSubCategorySelect(newValue ?? '');
        }}
        inputValue={subCategoryInputValue}
        onInputChange={(event, newInputValue) => {
          setSubCategoryInputValue(newInputValue);
        }}
        id="sub-category-select"
        options={FMSFolderStructure?.subCategory || []}
        renderInput={(params) => <TextField {...params} label="Sub Category" />}
        sx={{background: Primary[50], flex: 1}}
      />
    </React.Fragment>
  )
}

export default AdditionalFilters;